import { getLossStockNameList } from "@/api/Loss.js";
// import  { HubConnectionBuilder, LogLevel } from "@microsoft/signalr";
import MobileOrder from "../MobileOrder.vue";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { GetMobileOrderQuantity } from "@/api/ProductCategory.js";
export default {
  components: {
    MobileOrder,
    VuePerfectScrollbar,
  },
  data() {
    return {
      searchQuery: '',
      productPlaceHolder: require("@/assets/images/products/product-kahve.png"),
      breadCrumbItems: [],
      currentBreadCrumbIndex: 0,
      breadCrumbId: 0,
      productDetailActive: false,
      stocks: [],
      stockNameFilter: null,
      filteredStocks: [],
      newOrder: false,
      orderQuantity: 0,
      orderListIsActive: false,
      pendingCategoryScrollReset: false,
    };
  },
  props: {
    productList: null,
    isTableMode: false,
    imageEnabled: false
  },
  computed: {
    hasNeedNavigationByQuestion() {
      return this.$store.getters["selfservice/hasNeedNavigationByQuestion"];
    },
    hasAnySelectedStockLoss() {
      let bool = this.stocks.some((x) => x.isSelected);
      return !bool;
    },
    lossTypeSelection: {
      get() {
        return this.$store.getters["selfservice/getLossType"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossType", val);
      },
    },
    selectedLossStocks() {
      return this.$store.getters["selfservice/getSelectedLossStocks"];
    },
    lossMode: {
      get() {
        return this.$store.getters["selfservice/getLossMode"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setLossMode", val);
      },
    },
    currentCart: function () {
      return this.$store.getters["selfservice/getCurrentCart"];
    },
    isReset: {
      get() {
        return this.$store.getters["selfservice/getToIsReset"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setIsReset", val);
      },
    },
    currentProductList() {
      if (this.productList != null) {
        let itemsToFilter = [];
        const query = (this.searchQuery || "").trim().toLowerCase();

        if (query !== "") {
          // Global arama: Tüm ağaçtaki ürün ve kategorileri düzleştirip getir.
          itemsToFilter = this.getAllFlattenedItems(this.productList);
        } else {
          // Normal breadcrumb bazlı liste
          itemsToFilter = this.breadCrumbItems.length > 0
            ? (this.breadCrumbItems[this.currentBreadCrumbIndex].dataSet || [])
            : [];
        }

        const filteredProducts = itemsToFilter.filter(item => 
          (item.name || "").toLowerCase().includes(query)
        );

        // A-Z Sıralama (Türkçe karakter duyarlı)
        return [...filteredProducts].sort((a, b) => {
          return (a.name || "").localeCompare(b.name || "", 'tr', { sensitivity: 'base' });
        });
      } else {
        return [];
      }
    },
    isScreenLock: {
      get() {
        return this.$store.getters["selfservice/getScreenLock"];
      },
      set(val) {
        this.$store.dispatch("selfservice/setScreenLock", val);
      },
    },
    currentTab: {
      get() {
        return this.$store.getters["selfservice/getCurrentTab"];
      },
    },
  },
  watch: {
    currentProductList: {
      handler() {
        const shouldResetToTop = this.pendingCategoryScrollReset;
        this.pendingCategoryScrollReset = false;
        this.$nextTick(() => {
          // Small delay to ensure DOM is fully rendered
          setTimeout(() => {
            this.adjustProductNameScaling();
            this.$emit("refresh-main-scroll", { resetToTop: shouldResetToTop });
          }, 100);
        });
      },
      deep: true
    },
    hasNeedNavigationByQuestion(val) {
      if (val) {
        this.navigateByQuestion();
      }
    },
    stockNameFilter(val) {
      this.setStockFilter(val);
    },
    lossMode(val) {
      if (val) {
        if (this.stocks.length > 0) return;
        this.getLossStockNameList();
      }
    },
    isReset(val) {
      if (!val) return;
      this.$store.dispatch("selfservice/removeCart", this.currentCart.id);
      this.$store.dispatch("selfservice/setSelectedProduct", null);
      this.$store.dispatch("selfservice/setPreSelectedProduct", null);
      this.$store.dispatch("selfservice/setToUpdateEntry", null);
      this.$store.dispatch("selfservice/clearSelectedLossStocks");
      this.lossTypeSelection = true;
      this.onClickBreadCrumb(this.breadCrumbItems[0], 0);
      if (this.stocks.length > 0) {
        this.stocks.forEach((x) => {
          x.quantity = null;
          x.isSelected = false;
        });
      }
      this.isReset = false;
    },
    selectedLossStocks: {
      deep: true,
      handler(val) {
        let selectedStocks = this.stocks.filter((x) => x.isSelected);
        if (val && val.length == 0) {
          selectedStocks.forEach((x) => {
            x.isSelected = false;
            x.quantity = null;
          });
        } else if (
          val &&
          val.length > 0 &&
          val.length < selectedStocks.length
        ) {
          selectedStocks.forEach((x) => {
            if (!val.some((y) => y.id == x.id)) {
              x.isSelected = false;
              x.quantity = null;
            }
          });
        }
      },
    },
  },
  created: async function () {
    await this.getLossStockNameList();
    this.orderQuantity = await GetMobileOrderQuantity();
    if (this.orderQuantity > 0) {
      this.newOrder = true;
    }
  },
  mounted: function () {
    this.initializeComponent();
    this.$nextTick(() => {
      this.adjustProductNameScaling();
    });
  },
  methods: {
    adjustProductNameScaling() {
      const elements = document.querySelectorAll('.category-product-name');
      elements.forEach(el => {
        // Reset scale first
        el.style.setProperty('--scale-factor', '1');

        const parent = el.parentElement;
        const parentWidth = parent.clientWidth;
        const parentHeight = parent.clientHeight;

        // Check if text overflows after allowing line breaks
        if (el.scrollHeight > parentHeight) {
          // Calculate scale factor based on height overflow
          let scale = Math.min(0.8, parentHeight / el.scrollHeight);
          // Don't scale smaller than 0.6
          scale = Math.max(0.6, scale);
          el.style.setProperty('--scale-factor', scale);
        }
      });
    },
    goBack() {
      if (this.currentBreadCrumbIndex > 0) {
        this.onClickBreadCrumb(this.breadCrumbItems[this.currentBreadCrumbIndex - 1], this.currentBreadCrumbIndex - 1);
      } else {
        this.$emit('switchToTableMap');
      }
    },
    refreshOrderQuantity: async function () {
      this.orderQuantity = await GetMobileOrderQuantity();
      if (this.orderQuantity > 0) {
        this.newOrder = true;
      }
    },
    openMobileOrders() {
      this.newOrder = false;
      this.orderListIsActive = true;
      this.$refs.mobileOrder.getOrder();
      //window.open('/pages/MobileOrder', 'myWindow', 'width=800,height=600');
    },
    setStockSelect(stock) {
      stock.isSelected = true;
      this.$store.dispatch("selfservice/addSelectedLossStock", stock);
    },
    // eslint-disable-next-line no-undef
    setStockFilter: _.debounce(function (val) {
      this.filteredStocks = this.stocks.filter((x) =>
        x.name.toLowerCase().includes(val.toLowerCase())
      );
    }, 500),
    getLossStockNameList() {
      getLossStockNameList()
        .then((res) => {
          if (res && res.status) {
            this.stocks = res.data;
            this.setStockFilter("");
          } else {
            this.$fire({
              title: "Hata : " + res.status,
              text: "Stok Listesi Bulunamadı !",
              type: "error",
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Stok Listesi Bulunamadı !",
            });
          }
        })
        .catch(() => {
          this.$fire({
            title: "Hata !",
            text: "Sunucuya Bağlantı Hatası !",
            type: "error",
          });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucuya Bağlantı Hatası !",
          });
        });
    },
    scrollTop() {
      let element = document.getElementById("dataList");

      element.scrollBy(0, -100);
    },
    scrollDown() {
      let element = document.getElementById("dataList");
      element.scrollBy(0, 100);
    },
    getAllFlattenedItems(dataSet) {
      let all = [];
      if (!dataSet || !Array.isArray(dataSet)) return all;
      
      dataSet.forEach(item => {
        // Ürünü/Kategoriyi ekle
        all.push(item);
        
        // Varsa alt kategorileri ekle
        if (item.childCategories && item.childCategories.length > 0) {
          all.push(...this.getAllFlattenedItems(item.childCategories));
        }
        
        // Varsa alt ürünleri ekle
        if (item.products && item.products.length > 0) {
          all.push(...this.getAllFlattenedItems(item.products));
        }
      });
      
      // Tekrar edenleri (id bazlı) temizle - Ağaç yapısında bir ürün birden fazla yerde olabilir
      return all.filter((item, index, self) =>
        index === self.findIndex((t) => t.id === item.id)
      );
    },
    checkChildren: function (product) {
      if (product.children) {
        if (product.children.length == 1 && product.children[0].recipe) {
          return product.children[0].price.toString() + "₺";
        }
      }
      return null;
    },

    initializeComponent: async function () {
      this.breadCrumbItems = [
        {
          name: "Kategoriler",
          id: this.breadCrumbId++,
          dataSet: this.productList,
        },
      ];
    },
    navigateByQuestion() {
      let navigationQuestion =
        this.$store.getters["selfservice/getNavigationQuestion"];
      this.onClickBreadCrumb(this.breadCrumbItems[0], 0);
      if (navigationQuestion.categoryId) {
        let category = this.currentProductList.find(
          (x) => x.id === navigationQuestion.categoryId
        );
        this.onProductDetailClick(category);
        this.$store.dispatch("selfservice/setCurrentCartNavigatedByQuestion");
      }

      if (navigationQuestion.productId) {
        let product = this.currentProductList.find(
          (x) => x.id === navigationQuestion.productId
        );
        this.onProductDetailClick(product);
        this.$store.dispatch("selfservice/setCurrentCartNavigatedByQuestion");
      }
    },
    onClickBreadCrumb: function (selectedBreadCrumb, index) {
      this.pendingCategoryScrollReset = true;
      this.currentBreadCrumbIndex = index;
      this.breadCrumbItems.length = this.currentBreadCrumbIndex + 1;
      this.breadCrumbItems = [...this.breadCrumbItems];
    },
    onProductDetailClick: function (product) {
      let breadItem = {
        id: this.breadCrumbId++,
        name: product.name,
      };

      if (product.children) {
        if (product.children.length == 1 && product.children[0].recipe) {
          product.children[0].isSelected = true;
          this.$store.dispatch("selfservice/productSelectionCompleted", {
            product: product,
            sizeId: product.children[0].sizeId,
          });
          return;
        }
      }

      if (product.childCategories != null) {
        this.pendingCategoryScrollReset = true;
        breadItem.dataSet = product.childCategories;
        this.breadCrumbItems.push(breadItem);
        this.currentBreadCrumbIndex++;
      } else if (product.products != null) {
        this.pendingCategoryScrollReset = true;
        breadItem.dataSet = product.products;
        this.breadCrumbItems.push(breadItem);
        this.currentBreadCrumbIndex++;
      } else if (product.type) {
        this.SelectProduct(product);
      }
    },
    SelectProduct: function (product) {
      this.$store.dispatch("selfservice/setPreSelectedProduct", product);
    },
  },
};